/**
 * Vehicle entity model — ES module version of MyScripts/Entities/Vehicle.ts
 */

import type { VehicleData, AttachmentData, WarningData, ConnectionsData } from '@/services/api-types';

export type { VehicleData };

export const VEHICLE_DATE_FIELDS = ['plateIssued', 'plateExpires'] as const;

export function isVehicleDateField(name: string): boolean {
  return (VEHICLE_DATE_FIELDS as readonly string[]).includes(name);
}

export function createVehicle(data?: Partial<VehicleData>): VehicleData {
  return {
    id: null,
    make: null,
    model: null,
    year: null,
    color: null,
    plateState: null,
    plateNumber: null,
    plateCountry: null,
    temporaryPlate: null,
    plateIssued: null,
    plateExpires: null,
    insuranceCompanyName: null,
    insuranceExpires: null,
    insurancePolicyNumber: null,
    insuranceCompanyPhone: null,
    vin: null,
    bodyStyle: null,
    vehicleType: null,
    notes: null,
    descriptionPicId: null,
    attachmentList: [],
    createdByCompanyId: null,
    createdByCompanyName: null,
    warnings: [],
    connections: { people: [], vehicles: [], clients: [], businesses: [], reports: [] },
    ...data,
  };
}
